import { TeamPlanTier } from "@alch/dx-entities";
import { AnnouncementBanner } from "@alch/ui";
import usePlanPreference from "@features/profile/PlanPage/hooks/usePlanPreference";
import useTeam from "@queries/useTeam";
import { DateTime } from "luxon";

const CONTACT_US_URL =
  "mailto:vip@alchemyapi.io?subject=Sign%20Up%20for%20an%20Alchemy%20Contract&body=Hey%2C%20we'd%20like%20to%20sign%20up%20for%20a%20contract%20to%20use%20Alchemy%20as%20our%20node%20infrastructure%20platform.%0D%0A%0D%0AThanks!";

const TrialAnnouncementBanner = () => {
  const { data: team, isPending: isTeamLoading } = useTeam();
  const { data: planPreference } = usePlanPreference();

  if (
    !team ||
    !team.freeTrialDurationDays ||
    !team.freeTrialStartTime ||
    !planPreference ||
    (!isTeamLoading && planPreference.tier !== TeamPlanTier.OTHER)
  ) {
    return null;
  }
  const freeTrialStartTime = DateTime.fromISO(team.freeTrialStartTime);
  const freeTrialEndTime = freeTrialStartTime.plus({
    days: team.freeTrialDurationDays,
  });
  const daysLeft = Math.max(
    0,
    Math.ceil(freeTrialEndTime.diffNow("days").days),
  );

  if (daysLeft) {
    const formattedDay = daysLeft === 1 ? " day" : " days";
    return (
      <AnnouncementBanner>
        {`${daysLeft}${formattedDay} left in your VIP trial! 🎉`}
      </AnnouncementBanner>
    );
  }
  return (
    <AnnouncementBanner intent="warning">
      Your trial has expired!{" "}
      <AnnouncementBanner.Link
        href={CONTACT_US_URL}
        target="_blank"
        rel="noreferrer"
      >
        Contact us.
      </AnnouncementBanner.Link>
    </AnnouncementBanner>
  );
};

export default TrialAnnouncementBanner;
